/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Config\Cookies\CookiePathResolver.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday June 7th 2023 11:34:45 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { CookieConfig } from "./CookiePathResolver.type";

const COOKIE_CONFIG: CookieConfig = {
  USER: {
    FIELD_USER: "personnal/user_id",
    FIELD_USER_ID: "personnal/user_id/id",
    ROLE: "personnal/role",
    TOKEN: "personnal/token",
    REFRESH_TOKEN: "personnal/refresh",
  },
};

export default COOKIE_CONFIG;
